import {Component, OnInit} from '@angular/core';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';

@Component({
  selector: 'app-match-videos',
  templateUrl: './match-videos-tab.component.html',
  styleUrls: ['./match-videos-tab.component.scss']
})
export class MatchVideosTabComponent implements OnInit {

  constructor( public matchDetailViewService: MatchDetailViewService,
               private adCampaignService: AdCampaignService) { }

  public ngOnInit() {
    this.adCampaignService.setPlacement(AdCampaignPlacement.Ticker);
  }

  public hasVideos(): boolean {
    return this.matchDetailViewService.getActivitiesWithVideos()?.length > 0;
  }
}
